// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Rl2n","col":"styles_col__3UpRy"};